<div class="results" *ngIf="results.length">
    <fui-deprecated-autocomplete-control-result *ngFor="let result of results | slice:0:position" [result]="result">
        <ng-template #autocompletecontrolresult let-result="result">
            <ng-container [ngTemplateOutlet]="autocompleteControlResult"
                          [ngTemplateOutletContext]="$any({result: result})"></ng-container>
        </ng-template>
    </fui-deprecated-autocomplete-control-result>
    <div class="footer" *ngIf="hasShowMore()">
        <fui-local-button class="outline utility color-caribbean-green" (click)="showMore()" [title]="'fui.common.button.loadMore'"></fui-local-button>
    </div>
</div>
<div class="message" *ngIf="!results.length">
    <fui-empty [description]="'fui.autocomplete-control.message.noResultsDescription'" [title]="'fui.autocomplete-control.message.noResultsTitle'">
        <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
    </fui-empty>
</div>
